import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-input-form-group-component',
  templateUrl: './inputFormGroup.component.html',
  styleUrls: ['./inputFormGroup.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => InputFormGroupComponent),
      multi: true,
    },
  ],
})
export class InputFormGroupComponent implements ControlValueAccessor {
  @Input() name: string;
  @Input() id: string;
  @Input() formControl: FormControl;
  inputValue: string;

  private propagateChange = (_: any) => { };

  registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  private propagateTouch = (_: any) => { };

  registerOnTouched(fn: any) {
    this.propagateTouch = fn;
  }

  writeValue(value: string) {
    this.inputValue = value;
  }

  onKeyUp($event: KeyboardEvent) {
    this.inputValue = (<HTMLInputElement>$event.target).value;
    this.propagateChange(this.inputValue);
  }
}



// WEBPACK FOOTER //
// ./src/app/common/components/InputFormGroupComponent/inputFormGroup.component.ts